import { useState, useEffect } from 'react';
import {
  getAll, getOne
} from '../../../service/company/CompanyService';
import { CompanyModel } from '../models/CompanyModel';
import { useHistory } from 'react-router-dom';

export const useGetAll = (
  realoadGrid: number,
  startIndex: number,
  endIndex: number,
  filters: any
) => {
  const [data, setData] = useState<CompanyModel[]>([]);
  const [count, setCount] = useState(1);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(0);
      const res = await getAll(startIndex, endIndex, filters)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res.rows);
        setCount(res.count);
        setLoadingRequest(1);
      }
    };
    if (realoadGrid) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endIndex, realoadGrid]);
  return { data, count, loadingRequest };
};

export const useGetOne = (id: number) => {
  const initModel = {
    id: 0,
    nombre: "",
    code: "",
    razon_social: "",
    telefono: "",
    email: "",
    nombre_contacto: "",
    nombre_responsable: "",
    calle: "",
    numero_exterior:"",
    numero_interior: "",
    colonia: "",
    municipio: "",
    estado: "",
    codigo_postal: "",
    pais: "",
    longitud: 0,
    latitud: 0,
    sitio_web: "",
    industria: {
        id: 0,
        name: "",
        code: "",
    }
  };

  const [initValues, setInitValues] = useState<CompanyModel>(initModel);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getOne(id)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setInitValues(res);
      }
    };
    if (id) {
      fetchPost();
    } else {
      setInitValues(initModel);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return { initValues };
};